<div class="price-card" [class.featured]="price().status !== 1">
  <!-- Popular badge -->
  <div class="popular-badge" *ngIf="price().status !== 1">
    <i class="bi bi-star-fill"></i> Most popular
  </div>

  <!-- Discount ribbon -->
  <div class="discount-ribbon" *ngIf="price().discount !== undefined && price().discount.discount > 0">
    {{price().discount.discount}}% OFF
  </div>

  <!-- Instagrammer view -->
  <div *ngIf="(userState | async).user.type === 1" class="card-body-content">
    <div class="plan-duration">
      <span *ngIf="+price().permissions['auditor.limit'].periodic_count === 1">Monthly</span>
      <span *ngIf="+price().permissions['auditor.limit'].periodic_count === 12">Yearly</span>
    </div>

    <div class="plan-price">
      <span class="currency">$</span>
      <span class="amount">{{ (price().discount !== undefined ?
        (+price().permissions['auditor.limit'].periodic == 1 ? +price().permissions['auditor.limit'].periodic_count : 1) * price().unit_price * price().units * (1 - (price().discount.discount / 100))
        : (+price().permissions['auditor.limit'].periodic == 1 ? +price().permissions['auditor.limit'].periodic_count : 1) * price().unit_price * price().units) | number:'1.0-0' }}</span>
    </div>

    <p class="plan-per" *ngIf="price().discount !== undefined">
      ${{ price().unit_price * (1 - (price().discount.discount / 100)) | number:'1.0-1' }} / month
    </p>
    <p class="plan-per" *ngIf="price().discount === undefined && +price().permissions['auditor.limit'].periodic_count === 12">
      ${{ price().unit_price | number:'1.0-1' }} / month
    </p>

    <ul class="plan-features">
      <li><i class="bi bi-check-lg"></i> Full audience analysis</li>
      <li><i class="bi bi-check-lg"></i> Engagement metrics</li>
      <li><i class="bi bi-check-lg"></i> Follower quality score</li>
      <li *ngIf="+price().permissions['auditor.limit'].periodic_count === 12">
        <i class="bi bi-check-lg"></i> Shareable certificate
      </li>
    </ul>
  </div>

  <!-- Marketer view -->
  <div *ngIf="(userState | async).user.type !== 1" class="card-body-content">
    <div class="plan-duration">
      {{price().units}} <span *ngIf="price().units === 1">report</span><span *ngIf="price().units > 1">reports</span> / month
    </div>

    <div class="plan-price">
      <span class="currency">$</span>
      <span class="amount" *ngIf="price().discount !== undefined">{{ price().unit_price * (1 - (price().discount.discount / 100)) | number:'1.0-0' }}</span>
      <span class="amount" *ngIf="price().discount === undefined">{{ price().unit_price | number:'1.0-0' }}</span>
      <span class="per-unit">/ report</span>
    </div>

    <p class="plan-billed">
      Billed
      {{ (price().discount !== undefined ?
        (+price().permissions['auditor.limit'].periodic == 1 ? +price().permissions['auditor.limit'].periodic_count : 1) * price().unit_price * price().units * (1 - (price().discount.discount / 100))
        : (+price().permissions['auditor.limit'].periodic == 1 ? +price().permissions['auditor.limit'].periodic_count : 1) * price().unit_price * price().units) | number:'1.0-2' }}$
      <span *ngIf="+price().permissions['auditor.limit'].periodic_count === 1">per month</span>
      <span *ngIf="+price().permissions['auditor.limit'].periodic_count === 12">per year</span>
    </p>

    <ul class="plan-features">
      <li><i class="bi bi-check-lg"></i> Full audience analysis</li>
      <li><i class="bi bi-check-lg"></i> Engagement metrics</li>
      <li><i class="bi bi-check-lg"></i> Bulk audit reports</li>
    </ul>
  </div>

  <!-- CTA Button -->
  <button
    (click)="onSelectPayment(price())"
    class="btn-cta"
    [class.btn-cta-secondary]="+price().permissions['auditor.limit'].periodic_count === 1 && price().status === 1"
    [class.btn-cta-primary]="price().status !== 1 || +price().permissions['auditor.limit'].periodic_count !== 1"
    [disabled]="(paymentState | async).paymentLoader.pay"
  >
    <span *ngIf="!(paymentState | async).paymentLoader.pay">Get started</span>
    <span class="btn-loading" *ngIf="(paymentState | async).paymentLoader.pay">
      <span class="spinner"></span> Processing...
    </span>
  </button>
</div>